import React, { PureComponent, Fragment } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import LoginForm from './LoginForm';
import history from '../../history';
import { logout } from '../../Store/actions/loginActions';
import { alertMessageRemoval } from '../../Store/actions/signupActions';
import { AJAX_REQUEST, sentryErrorLog } from '../../Constants/AppConstants';

class Login extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
        if (this.props.isAuthenticated) {
            AJAX_REQUEST("POST", "operator/details", {}).then(results => {

                // Sentry Log create
                sentryErrorLog(results);

                const response = results.response;
                if (parseInt(response.code) === 1000) {
                    history.push('/');
                } else {
                    this.props.logout();
                }
            });
        }
        document.title = "Login - ALAN Live Chat Operator";
    }

    componentDidMount() {
        document.querySelector("body").scrollIntoView();
        this.setState({
            loading: false
        });
        setTimeout(() => {
            localStorage.setItem("idleTimeLeft", 0);
        }, 2000)
        setTimeout(() => {
            localStorage.setItem("idleTimeLeft", 0);
        }, 5000)
    }

    render() {
        return (
            <Fragment>
                {
                    this.state.loading ?
                        <div className="loading"></div>
                        :
                        <React.Fragment>
                            <div className="container login_container">
                                <div className="row login_row">
                                    <div className="col-md-12">
                                        <main className="">
                                            <div className="user_login">
                                                <h2 className="montserrat">Login</h2>
                                                <LoginForm />
                                            </div>
                                        </main>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                }
            </Fragment>

        );
    }
}

Login.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    alertMessageRemoval: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.isAuthenticated
    }
}

export default connect(mapStateToProps, { logout, alertMessageRemoval })(Login);
